module.exports = __webpack_public_path__ + "static/media/slide-xs-2.4b064217.png";